import { Card } from '@acceso/design-system';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { GeneralHeader } from '@/components/HeaderPage/HeaderPage';
import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';
import { TSegmentMention } from '@/features/segments/types';
import { convertISOToSeconds } from '@/utils/hh-mm-ss-into-number';

import { BroadcastScheduleProgramBodySegmentToolkitMentionTable } from './components/BroadcastScheduleProgramBodySegmentToolkitMentionTable';

export default function BroadcastScheduleProgramBodySegmentToolkitMention() {
  const { t } = useTranslation();
  const { activeSegment, videoControlRef } = useBroadcastScheduleProgram();

  const handlePreviewBox = (box: TSegmentMention) => {
    if (!activeSegment) return;

    const seconds = convertISOToSeconds(box.start_datetime, new Date(activeSegment.start_datetime));

    videoControlRef.current?.seekToSecond(seconds || 0);
  };

  return (
    <Card
      classes={{
        rootSection: clsx('w-full flex-auto order-3 lg:order-2'),
        container: 'py-size-4',
      }}
    >
      <div className="flex w-full flex-col gap-2">
        <GeneralHeader name={t('Keywords')} />
        <BroadcastScheduleProgramBodySegmentToolkitMentionTable
          items={activeSegment?.segment_mentions || []}
          onPreview={handlePreviewBox}
        />
      </div>
    </Card>
  );
}
